// Cederart theme — motion
(function () {
  // Scroll reveal with stagger
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  document.querySelectorAll('.work-grid .work').forEach(function (el, i) {
    el.style.transitionDelay = (i % 3) * 110 + 'ms';
  });

  if (!matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

  // Subtle parallax on hero artwork
  var heroArt = document.querySelector('.hero-art img, .hero-art svg');
  if (heroArt) {
    var ticking = false;
    addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        heroArt.style.transform = 'translateY(' + window.scrollY * -0.06 + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  // Gentle 3D tilt on gallery works (desktop pointers only)
  if (matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.work').forEach(function (w) {
      var media = w.querySelector('.media img, .media svg');
      if (!media) return;
      w.addEventListener('mousemove', function (e) {
        var r = w.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = 'perspective(700px) rotateX(' + (-y * 4) + 'deg) rotateY(' + (x * 4) + 'deg) translateY(-5px)';
      });
      w.addEventListener('mouseleave', function () { media.style.transform = ''; });
    });
  }

  // Product page: click thumbnail to swap main image
  var mainImg = document.querySelector('.product-media img');
  document.querySelectorAll('.product-thumbs img').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) { mainImg.src = t.dataset.full; mainImg.srcset = ''; }
    });
  });
})();

// Collection toolbar — live search filter + sort redirect
(function () {
  var input = document.querySelector('[data-grid-filter]');
  if (input) {
    var grid = document.querySelector('.work-grid');
    var empty = document.querySelector('.grid-empty');
    input.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();
      var shown = 0;
      grid.querySelectorAll('.work').forEach(function (w) {
        var hit = !q || w.textContent.toLowerCase().indexOf(q) !== -1;
        w.style.display = hit ? '' : 'none';
        if (hit) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    });
  }
  var sel = document.querySelector('[data-sort-redirect]');
  if (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      location.href = url.href;
    });
  }
})();

// Scrollmålning — photo paints itself while scrolling
(function () {
  var reduced = !matchMedia('(prefers-reduced-motion: no-preference)').matches;
  var instances = [];

  function smooth(t) { return t * t * (3 - 2 * t); }

  function paintAt(inst, p) {
    var e = smooth(p) * 130; // sweep past 100 so the soft edge clears the canvas
    inst.color.style.setProperty('--edge0', Math.max(0, e - 14) + '%');
    inst.color.style.setProperty('--edge1', e + '%');
    if (inst.pct) inst.pct.textContent = Math.min(100, Math.round(p * 100));
  }

  function scan() {
    instances = [];
    document.querySelectorAll('[data-scrollpaint]').forEach(function (track) {
      var inst = {
        track: track,
        color: track.querySelector('[data-sp-color]'),
        pct: track.querySelector('[data-sp-pct]')
      };
      if (!inst.color) return;
      if (reduced) {
        paintAt(inst, 1);
        var hint = track.querySelector('.scrollpaint-hint');
        if (hint) hint.style.display = 'none';
        return;
      }
      instances.push(inst);
    });
    update();
  }

  function update() {
    instances.forEach(function (inst) {
      var r = inst.track.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) { paintAt(inst, 1); return; }
      var p = Math.min(1, Math.max(0, -r.top / total));
      paintAt(inst, p);
    });
  }

  var ticking = false;
  addEventListener('scroll', function () {
    if (ticking || !instances.length) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }, { passive: true });

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', scan);
  scan();
})();

// Mobile nav (hamburger)
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;
  function setOpen(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    nav.classList.toggle('open', open);
    document.body.classList.toggle('nav-open', open);
  }
  toggle.addEventListener('click', function () {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });
  nav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });
  if (window.matchMedia) {
    var mq = matchMedia('(min-width: 941px)');
    if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) setOpen(false); });
  }
})();
